/**
 * @generated SignedSource<<4ff92316ab18fa3b2d2b4ccddf8e2aa1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TradeRule",
    "kind": "LinkedField",
    "name": "proposeCommunityTrade",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProposeCommunityTradeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProposeCommunityTradeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bced97172d6a4b7cabe99c2b030505d5",
    "id": null,
    "metadata": {},
    "name": "ProposeCommunityTradeMutation",
    "operationKind": "mutation",
    "text": "mutation ProposeCommunityTradeMutation(\n  $input: CommunityTradeProposal!\n) {\n  proposeCommunityTrade(input: $input) {\n    id\n    uuid\n  }\n}\n"
  }
};
})();

node.hash = "8ad408e2932b6f6b9ef9ce1b1e229aba";

module.exports = node;
